module.exports = __webpack_public_path__ + "b14135243159e9e6c830595d9f75806a.svg";